
import { Components, PanelItem, PanelItemGroup, PanelItemGroups } from '@rta/rta-blueprint-library';
import React, { useContext } from 'react';

import { AppContext } from '@r-app/app-context';
import { DisplayMode } from '@r-core';
import { RenderOverheadPanelItem } from './render-overhead-panel-item';
import { renderTracking } from '@r-services/render-tracking';

// Manufacturing modes where top-only appliances (pizza ovens, asado smokers,
// etc.) should be short-circuited from rendering — they sit on top of the
// countertop and have no MFG-relevant content to show.
const MFG_DISPLAY_MODES = new Set<DisplayMode>([
	DisplayMode.Manufacturing,
	DisplayMode.OverheadManufacturing
]);

type RenderOverheadPanelItemGroupsProps = {
	panelItemGroups: PanelItemGroups;
}

export const RenderOverheadPanelItemGroups = ({ panelItemGroups }: RenderOverheadPanelItemGroupsProps): React.ReactElement => {
	const { controller: { options, navigation }} = useContext(AppContext);

	renderTracking.incrementRender('ShowOverheadPanelItemGroups');

	const skipTopOnly = MFG_DISPLAY_MODES.has(navigation.displayMode);

	const elements = panelItemGroups && panelItemGroups.children.map((panelItemGroup: PanelItemGroup) => {
			return <g
				key={panelItemGroup.id}
				overflow="visible"
				type="panel-item-appliance group"
				transform={`translate(${panelItemGroup.center.x}, ${panelItemGroup.center.z})`}
			>{
				[...panelItemGroup.items.children]
					// short-circuit top-only appliances in any MFG view
					.filter((pi) => !(skipTopOnly && pi.item.placement === Components.PLACEMENT_TOP_ONLY && !pi.item.distanceBelowCountertop))
					.sort((a, b) => {
						const aVent = a.item.category?.isVent ? 1 : 0;
						const bVent = b.item.category?.isVent ? 1 : 0;
						return aVent - bVent;
					})
					.map((panelItem: PanelItem) => {
						return <RenderOverheadPanelItem panelItem={panelItem} designerOptions={options} key={panelItem.id} />
					})
			}</g>;
		// }

		// return null;
	});

	return <>{elements}</>;
};
